import { graphql } from '~/gql';

export const UserEventsDocument = graphql(`
  subscription UserEvents {
    userEvents {
      ... on MessageReceived {
        message {
          id
          conversationId
          senderId
          content
          createdAt
          sender {
            id
            email
          }
        }
      }
      ... on MatterActivityReceived {
        event {
          id
          matterId
          eventType
          actorId
          occurredAt
        }
      }
    }
  }
`);
